import React from "react";
import { View, StyleSheet, TouchableOpacity, Modal } from "react-native";
import { AntDesign, MaterialCommunityIcons } from "@expo/vector-icons";
import { observer } from "mobx-react";
import { BlurView } from "expo-blur";
import Colors from "../../Resources/Color";
import VideoComponent from "./VideoComponent";
import MediaManager from "../Classes/MediaManager";

const FullScreenVideoPlayer = observer(
  ({
    url,
    weekText,
    serieDetails,
    exerciseName,
    protocolSlot,
    protocolSlotColor,
  }) => {
    const mediaManager = MediaManager.getInstance();

    const handleClose = () => {
      mediaManager.closeFullScreenVideo();
      mediaManager.closeMediaPlayer();
    };

    const handleMinimize = () => {
      mediaManager.closeFullScreenVideo();
    };

    return (
      <Modal
        visible={mediaManager.showingFullScreenVideo}
        animationType="fade"
        transparent={true}
        onRequestClose={handleClose}
      >
        <View style={styles.container}>
          {/* Video Player Container */}
          <View style={styles.videoContainer}>
            <VideoComponent
              url={url}
              width="100%"
              style={styles.video}
              nativeControls={false}
              contentFit="contain"
              allowsFullscreen={false}
              allowsPictureInPicture={false}
              loop={true}
              muted={mediaManager.videoMuted}
              autoPlay={true}
              isFullScreen={true}
              showCustomControls={true}
              weekText={weekText}
              serieDetails={serieDetails}
              exerciseName={exerciseName}
              protocolSlot={protocolSlot}
              protocolSlotColor={protocolSlotColor}
            />
          </View>
        </View>
      </Modal>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(20, 20, 20, 1)",
  },
  blurBackground: {
    ...StyleSheet.absoluteFillObject,
    // backgroundColor: "rgba(15, 15, 15, 0.1)",
  },
  topRightButtons: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 10,
    flexDirection: "row",
    gap: 12,
  },
  topButton: {
    padding: 10,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: 20,
  },
  videoContainer: {
    width: "100%",
    // maxWidth: 1400,
    height: "100%",
    maxHeight: 750,
    marginVertical: 40,
  },
  video: {
    width: "100%",
    height: "100%",
  },
});

export default FullScreenVideoPlayer;
